import {
  HStack,
  Heading,
  Spacer,
  Stack,
  StackProps,
  Text,
} from "@chakra-ui/react";
import * as React from "react";

export interface PageHeaderProps extends Omit<StackProps, "title"> {
  children?: React.ReactNode;
  title: React.ReactNode;
  subtitle?: React.ReactNode;
}

export default function PageHeader(props: PageHeaderProps) {
  const { children, title, subtitle, ...rootProps } = props;
  return (
    <HStack align="flex-start" {...rootProps}>
      <Stack gap="0.5">
        <Heading textStyle="h1">{title}</Heading>
        {subtitle && (
          <Text color="fg.muted" fontSize="sm" lineHeight={"1.5" as any}>
            {subtitle}
          </Text>
        )}
      </Stack>
      <Spacer />
      {children}
    </HStack>
  );
}
